// src/components/Tabs/AddSteelHardnessMeasurements.js
// Модальное окно добавления измерений твердости стали основных элементов (2 вкладка)

import React, { useState } from 'react';
import {
    CModal,
    CModalHeader,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CButton,
    CForm,
    CFormLabel,
    CFormSelect,
    CFormInput,
    CInputGroup,
    CInputGroupText,
    CRow,
    CCol,
    CFormTextarea
} from '@coreui/react';
import { cilPlus } from '@coreui/icons';
import CIcon from '@coreui/icons-react';

import DirectorySteelGrade from '../../Directory/SteelGrade/DirectorySteelGrade';

const AddSteelHardnessMeasurements = ({ visible, onClose, onSave }) => {
    const [element, setElement] = useState('');
    const [mark, setMark] = useState('');
    const [hardnessHB, setHardnessHB] = useState('');
    const [tensileStrength, setTensileStrength] = useState('');
    const [steelGrade, setSteelGrade] = useState('');


    const [isDirectoryModalVisible, setIsDirectoryModalVisible] = useState(false);

    const elementOptions = [
        'Пояс',
        'Пояс надстройки',
        'Раскос',
        'Трубостойка',
        'Распорка',
        'Шпренгель',
        'Элемент усиления',
        'Раскос надстройки',
        'Ствол'
    ];

    const handleSave = () => {
        if (!element) {
            alert('Пожалуйста, выберите Элемент.');
            return;
        }

        const newMeasurement = {
            element,
            mark: mark ? parseFloat(mark) : null,
            hardnessHB: hardnessHB ? parseFloat(hardnessHB) : null,
            tensileStrength: tensileStrength ? parseFloat(tensileStrength) : null,
            steelGrade,
        };

        onSave(newMeasurement);
        setElement('');
        setMark('');
        setHardnessHB('');
        setTensileStrength('');
        setSteelGrade('');
    };

    // 3. Функция для открытия модального окна справочника
    const handleAddSteelGrade = () => {
        setIsDirectoryModalVisible(true);
    };

    // Функция для закрытия модального окна справочника
    const closeDirectoryModal = () => {
        setIsDirectoryModalVisible(false);
    };

    // Стили для ограничения размера модального окна
    const modalStyle = {
        maxHeight: '45vh',
        display: 'flex',
        flexDirection: 'column'
    };

    return (
        <>
            <CModal
                alignment="center"
                visible={visible}
                onClose={onClose}
                backdrop="static"
                size="lg"
                style={modalStyle}
            >
                <CModalHeader>
                    <CModalTitle>Добавить изменения</CModalTitle>
                </CModalHeader>
                <CModalBody style={{ overflowY: 'auto', flex: '1 1 auto' }}>
                    <CForm>
                        <CRow className="mb-3">
                            <CCol md="4">
                                <CFormLabel>Элемент</CFormLabel>
                            </CCol>
                            <CCol md="8">
                                <CFormSelect
                                    value={element}
                                    onChange={(e) => setElement(e.target.value)}
                                    options={[
                                        { label: 'Выберите элемент', value: '' },
                                        ...elementOptions.map(opt => ({ label: opt, value: opt }))
                                    ]}
                                    required
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="4">
                                <CFormLabel>Отметка</CFormLabel>
                            </CCol>
                            <CCol md="8">
                                <CInputGroup>
                                    <CInputGroupText>+</CInputGroupText>
                                    <CFormInput
                                        type="number"
                                        value={mark}
                                        onChange={(e) => setMark(e.target.value)}
                                        placeholder="Введите отметку"
                                        step="any"
                                    />
                                </CInputGroup>
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="4">
                                <CFormLabel>Твердость по Бринеллю, НВ</CFormLabel>
                            </CCol>
                            <CCol md="8">
                                <CFormInput
                                    type="number"
                                    value={hardnessHB}
                                    onChange={(e) => {
                                        const hbValue = e.target.value;
                                        setHardnessHB(hbValue);

                                        if (hbValue === '' || isNaN(hbValue)) {
                                            setTensileStrength('');
                                        } else {
                                            const hb = parseFloat(hbValue);
                                            const calculated = Math.round(112 + 2.4 * hb);
                                            setTensileStrength(calculated);
                                        }
                                    }}
                                    placeholder="Введите значение НВ"
                                    step="any"
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="4">
                                <CFormLabel>Временное сопротивление σв, МПА</CFormLabel>
                            </CCol>
                            <CCol md="8">
                                <CFormInput
                                    type="number"
                                    value={tensileStrength}
                                    readOnly
                                    placeholder="Вычисляется автоматически"
                                    step="any"
                                />
                            </CCol>
                        </CRow>

                        <CRow className="mb-3">
                            <CCol md="4">
                                <CFormLabel>Марка стали</CFormLabel>
                            </CCol>
                            <CCol md="8">
                                <CInputGroup>
                                    <CFormTextarea
                                        value={steelGrade}
                                        onChange={(e) => setSteelGrade(e.target.value)}
                                        placeholder="Введите марку стали"
                                        rows={1}
                                    />
                                    <CButton
                                        type="button"
                                        color="primary"
                                        variant="outline"
                                        onClick={handleAddSteelGrade} // Используем обновленную функцию
                                        style={{ maxHeight: '38px' }}
                                    >
                                        <CIcon icon={cilPlus} />
                                    </CButton>
                                </CInputGroup>
                            </CCol>
                        </CRow>
                    </CForm>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={onClose}>
                        Отменить
                    </CButton>
                    <CButton color="primary" onClick={handleSave}>
                        Сохранить
                    </CButton>
                </CModalFooter>
            </CModal>

            {/* 4. Добавляем модальное окно справочника */}
            <DirectorySteelGrade
                visible={isDirectoryModalVisible}
                onClose={closeDirectoryModal} // Передаем функцию закрытия
            />
        </>
    );
};

export default AddSteelHardnessMeasurements;